module.exports = __webpack_public_path__ + "img/deploy-app-1.187a4c6a.png";